import { apiFetch, companyHeader, API_BASE_URL } from './prospects.js';

export function campaignEmailBannerImageUrl(campaign) {
  const id = campaign?._id || campaign?.id;
  if (!id || !campaign?.emailTemplateBannerUrl) return '';
  if (!campaign?.emailTemplateBannerKey) return campaign.emailTemplateBannerUrl;

  const params = new URLSearchParams();
  const cacheKey =
    campaign?.updatedAt ||
    campaign?.emailTemplateBannerKey ||
    campaign?.emailTemplateBannerOriginalName ||
    '';
  if (cacheKey) params.set('v', String(cacheKey));
  if (campaign?.companyId) params.set('c', String(campaign.companyId));
  const qs = params.toString();
  return `${API_BASE_URL}/campaigns/${encodeURIComponent(id)}/email-banner-image${
    qs ? `?${qs}` : ''
  }`;
}

export function campaignEmailTemplateBannerImageUrl(campaign, template) {
  const id = campaign?._id || campaign?.id;
  const templateId = template?._id || template?.id;
  if (!id || !templateId || !template?.emailTemplateBannerUrl) return '';
  if (!template?.emailTemplateBannerKey) return template.emailTemplateBannerUrl;

  const params = new URLSearchParams();
  const cacheKey =
    template?.updatedAt ||
    template?.emailTemplateBannerKey ||
    template?.emailTemplateBannerOriginalName ||
    '';
  if (cacheKey) params.set('v', String(cacheKey));
  if (campaign?.companyId) params.set('c', String(campaign.companyId));
  const qs = params.toString();
  return `${API_BASE_URL}/campaigns/${encodeURIComponent(
    id,
  )}/email-templates/${encodeURIComponent(templateId)}/banner-image${
    qs ? `?${qs}` : ''
  }`;
}

export async function fetchCampaigns() {
  return apiFetch('/campaigns');
}

export async function fetchCampaignById(id) {
  return apiFetch(`/campaigns/${id}`);
}

/** Notifications HubUP scrapées pour la communauté liée à la campagne. */
export async function fetchCampaignHubupNotifications(campaignId) {
  return apiFetch(
    `/campaigns/${encodeURIComponent(campaignId)}/hubup-notifications`,
  );
}

export async function createCampaign(data) {
  return apiFetch('/campaigns', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateCampaign(id, data) {
  return apiFetch(`/campaigns/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function uploadCampaignEmailBanner(id, file) {
  const form = new FormData();
  form.append('file', file);
  return apiFetch(`/campaigns/${id}/email-banner`, {
    method: 'POST',
    body: form,
  });
}

export async function saveCampaignEmailTemplate(id, data) {
  return apiFetch(`/campaigns/${id}/email-templates`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function deleteCampaignEmailTemplate(id, templateId) {
  return apiFetch(
    `/campaigns/${id}/email-templates/${encodeURIComponent(templateId)}`,
    {
      method: 'DELETE',
    },
  );
}

export async function sendCampaignEmailing(id, data) {
  return apiFetch(`/campaigns/${id}/emailing`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function publishCampaignHubupNotification(id, data) {
  const token = localStorage.getItem('authToken');
  const res = await fetch(
    `${API_BASE_URL}/campaigns/${encodeURIComponent(id)}/hubup-notifications`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...companyHeader(),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(data),
    },
  );
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.data?.message || `API error: ${res.status}`);
    err.data = body?.data;
    throw err;
  }
  return body;
}

export async function deleteCampaign(id) {
  return apiFetch(`/campaigns/${id}`, {
    method: 'DELETE',
  });
}

export async function uploadCampaignPdf(id, file) {
  const form = new FormData();
  form.append('file', file);
  return apiFetch(`/campaigns/${id}/pdf`, {
    method: 'POST',
    body: form,
  });
}

export async function fetchCampaignPdfUrl(id) {
  return apiFetch(`/campaigns/${id}/pdf-url`);
}
